// This file is auto-generated by git-version.js
module.exports.GitInfo = {
  version: '2.0.0',
  commitHash: '4fef5d93',
  sentryRelease: 'civix-frontend@2.0.0-4fef5d93',
};
